module.exports = __webpack_public_path__ + "static/media/caret-square-left.05058607.svg";